import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { AppState, campagneSelector } from '../../common/store/store';
import { Contact } from './Contact';
import { HeadSection } from './HeadSection';
import { HomeContactTel } from './HomeContactTel';
import { MasterViewPage } from './MasterPage';
import { SeoStuff } from './SeoStuff';


export const Campagne = () => {

    const campagne = useSelector((state: AppState) => campagneSelector.selectById(state, state.viewCampagne.campagneId ?? 0));
    const title = campagne?.title;
    const description = campagne?.description;

    return <MasterViewPage>
        {title && campagne ? <Box sx={{ backgroundImage: "url('images/chalet_patio_sur_pieux.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <Box className='dark header'>
                <Container sx={{ opacity: 1, pt: { xs: 4, sm: 4, md: 4, lg: 8 }, pb: { xs: 1, sm: 1, md: 3, lg: 5 }, textAlign: 'center', textShadow: '0px 0px 5px black' }}>
                    <Typography variant='h2'><strong className='white'>{title}</strong></Typography>
                    <Typography variant='h4' sx={{ margin: '0 auto' }}>{description?.split('\n').map((p, i) => <p key={i}>{p}</p>)}</Typography>
                    <Box component='img' alt='Logo Pieux Protech' title='Logo Pieux Protech' src="/images/PieuxProTechBlanc.png" sx={{ maxHeight: '200px' }}></Box>
                </Container>
            </Box>
        </Box> : <HeadSection />}
        <div className="dark"><HomeContactTel /></div>
        <Contact />
        <SeoStuff />
    </MasterViewPage >;
};
